import { OPTION_TYPE_CONSTANTS } from 'features/Option/constants/optionContants'
import type { ISlotExtensionRoom } from 'features/Option/interfaces/IOptionShop'
import type { IOptionShopCartItem } from 'features/Option/interfaces/IOptionShopCartItem'

const PACKAGE_EXT_UI_ID_SCALE = 100_000

const resolvePackageExtensionRoomTypeId = (room: ISlotExtensionRoom): number => {
  if (typeof room.room_type_id === 'number') return room.room_type_id
  if (room.code < 0) return Math.floor(-room.code / PACKAGE_EXT_UI_ID_SCALE)
  return 0
}

const mapPackageExtensionRoomForApi = (room: ISlotExtensionRoom): ISlotExtensionRoom => {
  const apiCode: number | null =
    room.listing_code === null
      ? null
      : typeof room.listing_code === 'number'
        ? room.listing_code
        : room.code

  return {
    name: room.name,
    code: apiCode,
    price: room.price,
    slot_id: room.slot_id,
    is_active: room.is_active,
    lease_room_id: room.lease_room_id,
    room_type_id: resolvePackageExtensionRoomTypeId(room),
    ...(room.date ? { date: room.date } : {}),
    ...(room.error_message ? { error_message: room.error_message } : {}),
  } as ISlotExtensionRoom
}

export const serializeShopCartForApi = (items: IOptionShopCartItem[]): IOptionShopCartItem[] =>
  structuredClone(items).map((lease) => {
    const ext = lease.optionSlotExtension
    const isPackageExt =
      ext?.option.price_type === OPTION_TYPE_CONSTANTS.PACKAGE_EXTENSION && ext.rooms?.length

    return {
      ...lease,
      options: lease.options?.filter(
        (opt) => opt.option.price_type !== OPTION_TYPE_CONSTANTS.PACKAGE_EXTENSION,
      ),
      optionSlotExtension:
        isPackageExt && ext
          ? {
              ...ext,
              rooms: ext.rooms.map(mapPackageExtensionRoomForApi),
            }
          : lease.optionSlotExtension,
    }
  })
